import { render, staticRenderFns } from "./DataAssetMovie.vue?vue&type=template&id=45fbaf45&scoped=true"
import script from "./DataAssetMovie.vue?vue&type=script&lang=js"
export * from "./DataAssetMovie.vue?vue&type=script&lang=js"
import style0 from "./DataAssetMovie.vue?vue&type=style&index=0&id=45fbaf45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fbaf45",
  null
  
)

export default component.exports